import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onMounted, onUnmounted, ref, provide } from 'vue'
import ImportExpedientsUploaderComponent
  from '@/views/Expedients/components/ImportExpedientsDialog/components/ImportExpedientsUploaderComponent.vue'
import ImportExpedientsLoadingComponent
  from '@/views/Expedients/components/ImportExpedientsDialog/components/ImportExpedientsLoadingComponent.vue'
import ImportExpedientsSummaryComponent
  from '@/views/Expedients/components/ImportExpedientsDialog/components/ImportExpedientsSummaryComponent.vue'
import {
  useImportExpedientsProcessStore
} from '@/views/Expedients/components/ImportExpedientsDialog/stores/useImportExpedientsProcessStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportExpedientsDialogComponent',
  props: {
  showDialog: {
    type: Boolean,
    required: true
  }
},
  emits: ['closeDialog'],
  setup(__props, { emit }) {



const STEPS_COMPONENTS = [
  ImportExpedientsUploaderComponent,
  ImportExpedientsLoadingComponent,
  ImportExpedientsSummaryComponent
]

const loaded = ref<boolean>(false)
const step = ref<number>(0)
const importExpedientsProcessStore = useImportExpedientsProcessStore()

const currentStepComponent = computed(() => STEPS_COMPONENTS[step.value])


provide('closeDialog', () => emit(
  'closeDialog',
  importExpedientsProcessStore?.importSummary?.successCount ?? 0
))
provide('nextStep', () => step.value++)
provide('prevStep', () => step.value--)
provide('resetStep', () => step.value = 0)

function blockAppPointerEvents() {
  const app = document.querySelector('.v-application')
  const dialog = document.querySelector('.v-dialog__content.v-dialog__content--active')
  if (app && dialog) {
    app.classList.add('print-or-save-invoice-dialog')
    dialog.classList.add('print-or-save-invoice-dialog')
  }
}

function unblockAppPointerEvents() {
  const app = document.querySelector('.v-application')
  app!.classList.remove('print-or-save-invoice-dialog')
}

onBeforeMount(() => loaded.value = true)
onMounted(() => {
  importExpedientsProcessStore.init()
  blockAppPointerEvents()
})
onUnmounted(() => {
  importExpedientsProcessStore.finish()
  unblockAppPointerEvents()
})

return { __sfc: true,STEPS_COMPONENTS, loaded, step, importExpedientsProcessStore, currentStepComponent, emit, blockAppPointerEvents, unblockAppPointerEvents }
}

})